import { render, staticRenderFns } from "./articleInfo.vue?vue&type=template&id=15a030d8&scoped=true"
import script from "./articleInfo.vue?vue&type=script&lang=js"
export * from "./articleInfo.vue?vue&type=script&lang=js"
import style0 from "./articleInfo.vue?vue&type=style&index=0&id=15a030d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a030d8",
  null
  
)

export default component.exports